import { NextSeo } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { Routes } from "~/routes";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { Footer } from "~/components/Footer";
import { PageHeader } from "~/components/PageHeader";
import { FilterMetadata, QueryResponse } from "~/modules/filters/types";
import { Asset } from "~/modules/assets/types";
import { queryAssetFilterMeta, queryAssets } from "~/modules/assets/api/router";
import { DEFAULT_ASSET_LIST_QUERY } from "~/modules/assets/consts";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";
import { FeatureNames } from "~/modules/feature_flag/flags";
import { NEXTJS_REVALIDATE_TIMEOUT } from "~/server/consts";
import { AssetListing } from "~/modules/assets/pages/listing";

// // // //

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
// NOTE - this will have to be changed to hit api.rwa.xyz when the API has been updated
export async function getStaticProps() {
    // Make all requests in parallel + destructure responses
    const [listQueryResponse, filterMetadata] = await Promise.all([
        queryAssets({
            query: DEFAULT_ASSET_LIST_QUERY,
        }),
        queryAssetFilterMeta(),
    ]);

    return {
        props: {
            listQueryResponse,
            filterMetadata,
        },
        // Next.js will re-generate this page based on NEXTJS_REVALIDATE_TIMEOUT const
        revalidate: NEXTJS_REVALIDATE_TIMEOUT,
    };
}

export default function AssetListingPage(props: {
    listQueryResponse: QueryResponse<Asset>;
    filterMetadata: FilterMetadata[];
}) {
    const { listQueryResponse, filterMetadata } = props;

    return (
        <PageTrack>
            <NextSeo title="Assets" />
            <UserFetcher>{({ user }) => <Navbar user={user} />}</UserFetcher>

            <SidebarLayout pathname={Routes.assets}>
                {/* <Breadcrumbs
                            pages={[
                                {
                                    name: "Tools",
                                    current: false,
                                },
                                {
                                    name: "API Tools",
                                    current: false,
                                },
                                {
                                    name: "Assets",
                                    current: false,
                                },
                            ]}
                        /> */}
                <PageWrapper>
                    <PageHeader
                        title="Assets"
                        subtitle="Search and analyze key metrics in tokenized asset transactions"
                    />

                    <FeatureFlag
                        feature={FeatureNames.enableExperimentalFeatures}
                    >
                        <AssetListing
                            initialState={listQueryResponse}
                            filterMetadata={filterMetadata}
                        />
                    </FeatureFlag>

                    <Footer />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
